import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { TypographyComponent } from '../typography/typography.component'


@Component({
  selector: 'hyperkit-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  standalone: true,
  imports: [TypographyComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorComponent {
  /**
   * The error message to display.
   */
  @Input() public error = 'test' // Default value provided
}
